module.exports = __webpack_public_path__ + "img/2.1e5a0c17.jpg";